import React from 'react'
import Typography from '@/components/ui/Typography'
import Autocomplete from '@/components/ui/Autocomplete'
import { StepControls, ParamTemplateRequirement } from '@/features/templates'
import { useField } from 'formik'
import { capitalCase } from 'change-case'
import { useCustomObjectFieldOptions } from './ZendeskCustomObjectFieldStep.hooks'

export type ZendeskCustomObjectFieldStepProps = {
  name: string
  requirement: ParamTemplateRequirement
}

export const ZendeskCustomObjectFieldStep = ({ name, requirement }: ZendeskCustomObjectFieldStepProps) => {
  const [, { value }, { setValue }] = useField(name)
  const options = useCustomObjectFieldOptions()

  const onChange = async (fieldName: string, newValue: string) => {
    setValue(newValue)
  }

  return (
    <div style={{ width: 480 }} className={'d-flex flex-column gap-2'}>
      <div>
        <Typography variant={'xxl'}>{capitalCase(name)}</Typography>
        <Typography>{requirement.description}</Typography>
      </div>
      <Autocomplete name={name} value={value} onChange={onChange} options={options} />
      <StepControls disabled={!value} />
    </div>
  )
}
